<template>
  <div>
    <b-card
      title="Biuro Obsługi Klienta"
      body-class="text-center"
      class="title-inline"
    >
      <b-card-text class="mx-4" body-class="text-center">
        <div class="my-2">Pracujemy od poniedziałku do piątku</div>
        <div class="my-2">w godz. 8:00 - 16:00</div>
        <div class="my-2">tel. 76 854 79 58</div>
        <div class="font-weight-bold my-2">{{ bokEmail }}</div>
      </b-card-text>
    </b-card>
    <b-card>
      <b-row>
        <b-col lg="12">
          <p>
            <strong>Potrzebujesz szybkiej pomocy?</strong><br />
            Zapytaj Wirtualnego Asystenta SKP<sup>®</sup>.
          </p>
          <b-button
            size="lg"
            class="mx-1 btn-accept-color"
            @click="runChat"
            ref="submit"
            style="float: right; margin-top: -40px"
          >
            Chcę zadać pytanie
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="10">
          <p style="color: #1292a8">
            <strong
              >Dlaczego warto skorzystać z pomocy Wirtualnego Asystenta
              SKP<sup>®</sup>?</strong
            >
          </p>
        </b-col>
      </b-row>
      <b-row>
        <ul>
          <li>
            <strong>Dostępność 24/7</strong> – możesz kontaktować się z nim o
            każdej porze dnia i nocy
          </li>
          <li>
            <strong>Szybkie wsparcie</strong> – uzyskasz natychmiastową pomoc
            podczas składania zamówienia lub pracy z programem
          </li>
          <li>
            <strong>Precyzyjna odpowiedź</strong> – Asystent w kilka sekund
            zaproponuje rozwiązanie Twojego problemu
          </li>
          <li>
            <strong>Wygoda użycia</strong> – korzystanie z pomocy Asystenta jest
            proste i pozwala oszczędzać czas potrzebny na przygotowanie
            odpowiedzi telefonicznej lub mailowej przez BOK.
          </li>
        </ul>
      </b-row>
    </b-card>
    <b-form>
      <b-card title="Formularz kontaktowy" class="title-inline">
        <b-card-text>
          <b-row>
            <b-col lg="10">
              <p class="font-italic text-info">
                Uwaga! Aby wysłać wiadomość wypełnij wszystkie pola.
              </p>
              <b-form-group
                label-cols-lg="auto"
                label="Osoba do kontaktu"
                label-for="name"
              >
                <b-form-input
                  id="name"
                  v-model="name"
                  :state="validatedName"
                  placeholder="Imię i nazwisko"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="10">
              <b-form-group
                label-cols-lg="auto"
                label="Adres zwrotny"
                label-for="email"
              >
                <b-form-input
                  id="email"
                  v-model="email"
                  placeholder="E-mail"
                  :state="validatedEmail"
                  aria-describedby="email-feedback"
                ></b-form-input>
                <b-form-invalid-feedback id="email-feedback">
                  Nieprawidłowy email
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="10">
              <b-form-group
                label-cols-lg="auto"
                label="Wiadomość"
                label-for="description"
                class="mb-0"
              >
                <b-form-textarea
                  id="description"
                  v-model="description"
                  :state="validatedDesc"
                  placeholder="W czym możemy pomóc?"
                  rows="4"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="auto">
              <b-form-group
                label="Dołącz plik"
                label-cols-lg="auto"
                class="mb-1 row-with-legend"
              >
                <b-form-file
                  id="file"
                  v-model="files"
                  name="statement"
                  plain
                  class="mt-2"
                  accept=".jpg, .png, .pdf"
                  multiple
                ></b-form-file>
                <b-form-text id="file-help"
                  >Dozwolone formaty plików: jpg, png, pdf.</b-form-text
                >
              </b-form-group>
            </b-col>
            <b-col v-if="files.length > 0">
              <b-button @click="files = []" variant="link" class="pt-2"
                ><span v-if="files.length === 1">Usuń plik</span
                ><span v-else>Usuń pliki</span></b-button
              >
            </b-col>
          </b-row>
          <b-row>
            <b-form-checkbox
              id="permission"
              v-model="permission"
              :state="validatedPermission"
              name="permission"
              value="1"
              unchecked-value="0"
              class="mx-3 my-3"
            >
              Wyrażam zgodę na przetwarzanie moich danych osobowych zgodnie z
              obecną ustawą o ochronie danych osobowych w związku z realizacją
              zgłoszenia.
            </b-form-checkbox>
          </b-row>
        </b-card-text>
      </b-card>
      <b-row
        ><p v-if="errors.length"></p>
        <ul>
          <li v-for="error in errors" :key="error" class="text-danger">
            {{ error }}
          </li>
        </ul></b-row
      >
      <b-alert
        v-if="successAlert"
        v-model="successAlert"
        variant="success"
        dismissible
        class="mt-0 mb-2"
      >
        Dziękujemy, wiadomość została wysłana.
      </b-alert>
      <b-row class="mt-3">
        <b-button
          variant="success"
          class="ml-auto mx-3 btn-accept-color"
          @click.prevent="send()"
          >Wyślij</b-button
        >
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Contact',
  data() {
    return {
      description: '',
      permission: 0,
      files: [],
      bokSkp: process.env.MIX_BOK_SKP,
      bokSam: process.env.MIX_BOK_SAM,
      errors: [],
      successAlert: false,
      validated: false,
      fromEmail: null,
      fromName: null,
    };
  },
  computed: {
    ...mapGetters({
      program: 'getProgram',
      licence: 'auth/userLicence',
      client: 'auth/client',
      isTestAccountRegistered: 'auth/isTestAccountRegistered',
      isTestAccountUnregistered: 'auth/isTestAccountunRegistered',
    }),

    email: {
      get() {
        if (this.isTestAccountUnregistered) {
          return '';
        }
        return this.fromEmail
          ? this.fromEmail
          : this.client.E1 && this.client.E1.length > 0
          ? this.client.E1
          : '';
      },
      set(value) {
        this.fromEmail = value;
      },
    },
    name: {
      get() {
        if (this.isTestAccountUnregistered) {
          return '';
        }
        return this.fromName
          ? this.fromName
          : this.client.O1 && this.client.O1.length > 0
          ? this.client.O1
          : '';
      },
      set(value) {
        this.fromName = value;
      },
    },
    bokEmail() {
      return this.program === 'skp' ? this.bokSkp : this.bokSam;
    },
    validatedName() {
      return this.validated && this.name.length < 1 ? false : null;
    },
    validatedEmail() {
      const regex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      return this.validated &&
        (!regex.test(String(this.email).toLowerCase()) ||
          this.email.length === 0)
        ? false
        : null;
    },
    validatedDesc() {
      return this.validated && this.description.length < 1 ? false : null;
    },
    validatedPermission() {
      return this.validated && this.permission != 1 ? false : null;
    },
  },
  created() {
    this.$store.commit('order/resetOrder');
    this.$store.commit('order/resetSteps');
  },
  methods: {
    send() {
      this.errors = [];
      this.validated = false;
      this.validateForm();

      let data = new FormData();
      data.append('program', this.program);
      data.append('name', this.fromName ? this.fromName : this.name);
      data.append('email', this.fromEmail ? this.fromEmail : this.email);
      data.append('description', this.description);
      data.append('permission', this.permission);
      data.append('licence', this.licence);

      if (this.files.length > 0) {
        for (let i = 0; i < this.files.length; i++) {
          data.append('files[' + i + ']', this.files[i]);
        }
      }

      if (this.errors.length === 0) {
        axios
          .post('/api/sendContactForm', data, {
            headers: {
              'content-type': 'multipart/form-data',
            },
          })
          .then((response) => {
            this.successAlert = true;
            this.fromName = null;
            this.fromEmail = null;
            this.description = '';
            this.permission = 0;
            this.files = [];
          })
          .catch((error) => {
            this.errors.push('Błąd wysłania wiadomości.');
          });
      }
    },
    validateForm() {
      if (this.permission != 1) {
        this.validated = true;
        this.errors.push('Zaznacz zgodę na przetwarzanie danych osobowych.');
      }

      if (this.name.length < 3) {
        this.validated = true;

        this.errors.push('Uzupełnij osobę do kontaktu.');
      }

      let regex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!this.email || this.email.length < 1) {
        this.validated = true;
        this.errors.push('Uzupełnij adres zwrotny.');
      } else if (regex.test(String(this.email).toLowerCase()) === false) {
        this.errors.push('Niepoprawny adres e-mail.');
      }

      if (this.description.length < 4) {
        this.validated = true;

        this.errors.push('Uzupełnij wiadomość.');
      }
    },
    runChat() {
      document.getElementById('chatbase-bubble-button').click();
    },
  },
};
</script>

<style scoped></style>
